import { useState, useEffect } from 'react';

const slides = [
  {
    src: 'https://public.readdy.ai/ai/img_res/e7d7b0ebe9a44c88020666ab620902e1.jpg',
    brand: 'Mercedes-Benz S-Class',
  },

  {
    src: 'https://readdy.ai/api/search-image?query=mercedes-maybach-S680-ultra-luxury-sedan-two-tone-black-and-silver-paint-dark-cinematic-studio-setting-dramatic-lighting-golden-accents-flawless-coachbuilt-body-ultra-premium-automotive-photography-deep-black-background-wide-angle-opulent&width=1920&height=1080&seq=slide-maybach-3&orientation=landscape',
    brand: 'Mercedes-Maybach',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=porsche-911-turbo-S-dark-graphite-metallic-parked-in-a-minimalist-dark-studio-environment-cinematic-moody-lighting-with-subtle-golden-rim-light-ultra-luxury-automotive-photography-deep-black-background-flawless-paint-wide-angle-elegant&width=1920&height=1080&seq=slide-porsche-04&orientation=landscape',
    brand: 'Porsche',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=mercedes-benz-G550-luxury-SUV-deep-midnight-black-paint-side-profile-view-against-pure-black-seamless-studio-background-ultra-low-key-cinematic-lighting-thin-golden-rim-light-tracing-the-roofline-and-body-edges-creating-a-halo-effect-absolute-darkness-surrounding-the-vehicle-premium-luxury-automotive-editorial-photography-moody-noir-flawless-finish&width=1920&height=1080&seq=slide-mb-g5b&orientation=landscape',
    brand: 'Mercedes-Benz G-Class',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=aston-martin-DB12-midnight-black-luxury-grand-tourer-in-a-dark-dramatic-studio-setting-with-cinematic-low-key-lighting-golden-accent-reflections-ultra-premium-automotive-photography-minimalist-dark-background-flawless-body-lines-wide-angle&width=1920&height=1080&seq=slide-aston-06&orientation=landscape',
    brand: 'Aston Martin',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=mercedes-maybach-GLS-600-luxury-SUV-obsidian-black-dark-cinematic-studio-environment-dramatic-moody-lighting-golden-rim-light-ultra-premium-automotive-photography-minimalist-deep-black-background-flawless-paint-opulent-wide-angle&width=1920&height=1080&seq=slide-maybach-7&orientation=landscape',
    brand: 'Mercedes-Maybach GLS',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=bmw-M8-competition-dark-sapphire-metallic-luxury-coupe-in-a-moody-dark-studio-with-dramatic-cinematic-lighting-deep-shadows-and-subtle-golden-highlights-ultra-premium-automotive-photography-minimalist-black-background-flawless-paint-wide-angle&width=1920&height=1080&seq=slide-bmw-08&orientation=landscape',
    brand: 'BMW',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=lamborghini-urus-pearl-black-luxury-SUV-in-a-dark-dramatic-studio-setting-cinematic-lighting-deep-moody-shadows-subtle-golden-reflections-ultra-premium-automotive-photography-minimalist-dark-background-flawless-paint-finish-wide-angle&width=1920&height=1080&seq=slide-lambo-09&orientation=landscape',
    brand: 'Lamborghini',
  },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState<number | null>(null);
  const [transitioning, setTransitioning] = useState(false);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setPrev(current);
      setTransitioning(true);
      setCurrent((c) => (c + 1) % slides.length);
      setTimeout(() => {
        setPrev(null);
        setTransitioning(false);
      }, 2000);
    }, 6000);
    return () => clearInterval(interval);
  }, [current]);

  const goTo = (index: number) => {
    if (index === current || transitioning) return;
    setPrev(current);
    setTransitioning(true);
    setCurrent(index);
    setTimeout(() => {
      setPrev(null);
      setTransitioning(false);
    }, 2000);
  };

  return (
    <section id="home" className="relative w-full h-screen min-h-[820px] flex items-start overflow-hidden">

      {/* Slideshow layers */}
      {slides.map((slide, i) => (
        <div
          key={slide.src}
          className="absolute inset-0 transition-opacity duration-[2000ms] ease-in-out"
          style={{
            opacity: i === current ? 1 : i === prev ? 0 : 0,
            zIndex: i === current ? 1 : i === prev ? 0 : 0,
          }}
        >
          <img
            src={slide.src}
            alt={`${slide.brand} luxury vehicle at The Royal Collision Centre`}
            className="w-full h-full object-cover object-center scale-105"
            style={{
              transform: i === current ? 'scale(1.05)' : 'scale(1)',
              transition: 'transform 8s ease-in-out',
            }}
          />
        </div>
      ))}

      {/* Overlays */}
      <div className="absolute inset-0 z-10 bg-gradient-to-r from-black/92 via-black/65 to-black/25"></div>
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-black/85 via-transparent to-black/45"></div>

      {/* Gold shimmer line bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-px z-20 bg-gradient-to-r from-transparent via-yellow-600/50 to-transparent"></div>

      {/* Content */}
      <div className="relative z-20 w-full max-w-[1600px] mx-auto px-5 md:px-16 pt-[160px] md:pt-[180px] lg:pt-32">
        <div className="max-w-3xl">
          {/* Headline */}
          <div className="mb-3 md:mb-5"></div>
          <h1 className="font-serif text-3xl sm:text-4xl md:text-6xl lg:text-7xl leading-[1.15] mb-4 md:mb-6">
            <span className="text-yellow-400 italic">Indulge in the</span>
            <br />
            <span className="text-white font-bold">Royal Treatment</span>
            <br />
            <span className="text-white/80 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light">Exclusively at</span>
            <br />
            <span className="text-yellow-500 text-xl sm:text-2xl md:text-3xl lg:text-4xl tracking-widest uppercase font-light">The Royal Collision Centre</span>
          </h1>

          {/* Subheadline */}
          <p className="text-white/70 text-sm md:text-base lg:text-lg leading-relaxed max-w-xl mb-8 md:mb-12 font-light">
            We restore vehicles to flawless condition with unmatched attention to detail, perfect paint matching, and premium craftsmanship.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
            <button
              onClick={() => scrollTo('contact')}
              className="whitespace-nowrap flex items-center justify-center gap-2 md:gap-3 px-6 md:px-8 py-3 md:py-4 text-xs md:text-sm tracking-widest uppercase text-yellow-300 bg-gradient-to-r from-purple-800 via-purple-900 to-black border border-yellow-600/40 rounded-full hover:border-yellow-500 hover:from-purple-700 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-file-list-3-line"></i>
              Get an Estimate
            </button>
            <button
              onClick={() => scrollTo('contact')}
              className="whitespace-nowrap flex items-center justify-center gap-2 md:gap-3 px-6 md:px-8 py-3 md:py-4 text-xs md:text-sm tracking-widest uppercase text-yellow-400 bg-transparent border border-yellow-600/50 rounded-full hover:bg-yellow-900/20 hover:border-yellow-500 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-calendar-line"></i>
              Make an Appointment
            </button>
            <a
              href="tel:7606664151"
              className="whitespace-nowrap flex items-center justify-center gap-2 md:gap-3 px-6 md:px-8 py-3 md:py-4 text-xs md:text-sm tracking-widest uppercase text-white bg-gradient-to-r from-black to-gray-900 border border-white/20 rounded-full hover:border-yellow-600/50 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-phone-line text-yellow-500"></i>
              Call Now
            </a>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-6 md:gap-10 mt-10 md:mt-16 pt-6 md:pt-10 border-t border-yellow-700/20">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full border border-yellow-600/40 bg-yellow-900/10">
                <i className="ri-tools-line text-yellow-500 text-base md:text-lg"></i>
              </div>
              <div>
                <div className="text-white text-xs md:text-sm font-serif tracking-widest uppercase">Factory Trained</div>
                <div className="text-yellow-500/70 text-[10px] md:text-xs tracking-widest uppercase mt-0.5">Collision Centre</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-30 flex items-center gap-3">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className="cursor-pointer transition-all duration-500"
            aria-label={`Go to slide ${i + 1}`}
          >
            <div
              className={`rounded-full transition-all duration-500 ${
                i === current
                  ? 'w-8 h-1 bg-yellow-500'
                  : 'w-2 h-1 bg-white/30 hover:bg-yellow-600/50'
              }`}
            />
          </button>
        ))}
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-10 hidden md:flex flex-col items-center gap-2 z-30">
        <span className="text-yellow-600/60 text-xs tracking-[0.3em] uppercase rotate-90 origin-center mb-4">Scroll</span>
        <div className="w-px h-16 bg-gradient-to-b from-yellow-600/60 to-transparent"></div>
      </div>
    </section>
  );
}
